import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Navigate, useLocation, useParams } from "react-router-dom";
import PropTypes from "prop-types";
// hooks
import useAuth from "../hooks/useAuth";
// pages
import Login from "../pages/authentication/Login";
import LoadingScreen from "../components/LoadingScreen";
import { frontendPages } from "../routes/paths";
import { setHeader, setSession } from "src/utils/jwt";
// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

const useBasePath = () => {
  const location = useLocation();
  const params = useParams();
  if (Object.prototype.hasOwnProperty.call(params, "*")) {
    delete params["*"];
  }
  return location.pathname.split("/").length - 1 === 1
    ? location.pathname
    : Object.values(params).reduce(
        (path, param) => path.replace(`/${param}`, ""),
        location.pathname
      );
};

export default function AuthGuard({ children }) {
  const {
    isAuthenticated,
    isInitialized,
    isVerifyEmail,
    isPopupOpen,
    user,
    isSwitchingAccount,
    initialize,
  } = useAuth();
  const pathname = useBasePath();
  const [requestedLocation, setRequestedLocation] = useState(null);

  useEffect(() => {
    const cookieToken = Cookies.get("__afritas_token") || "";
    if (isAuthenticated && !cookieToken) {
      // logout();
    }
    if (!isAuthenticated && cookieToken) {
      setSession(cookieToken);
      setHeader();
      initialize();
    }
  }, [isAuthenticated]);

  if (isInitialized && !isSwitchingAccount) {
    if (!isAuthenticated && !frontendPages.includes(pathname) && !isPopupOpen) {
      return <Login />;
    }

    if (isAuthenticated && !isVerifyEmail && pathname !== "/verify") {
      return <Navigate to="/verify" />;
    }

    if (
      isAuthenticated &&
      isVerifyEmail &&
      user.user.type === "" &&
      pathname !== "/select-business-type"
    ) {
      return <Navigate to="/select-business-type" />;
    }

    if (isAuthenticated && frontendPages.includes(pathname)) {
      return <Navigate to="/" />;
    }

    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
  } else {
    return <LoadingScreen />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }
  // eslint-disable-next-line
  return <>{children}</>;
}
